import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { generateEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { CheckboxEntityInterface } from './checkbox-entity.schema'

export const createCheckbox = (
  parentId: string,
  defaultText: string,
  masterBlockId?: MasterBlockIdType,
): CheckboxEntityInterface => {
  return {
    ...generateEntity(EntityTypeEnum.Checkbox, parentId, masterBlockId),
    content: `<p>${defaultText}</p>`,
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    fontSize: 16,
    errorText: 'settings_options.checkbox_message',
    optional: false,
    textAlign: 'left',
  }
}
